<template>
  <div class="tab">
    <h3>政策建议与对策</h3>
    <div>
      <ul>
        <li>
          <a href="http://news.gmw.cn/2019-10/25/content_33263047.htm" target="_blank">光明日报光明调查：深化新时代农村留守儿童关爱保护与发展工作</a>
        </li>
        <li>
          <a href="http://dzb.rmzxb.com/index.aspx?date=2019-02-20&verOrder=09&banzi=8&paperType=rmzxb" target="_blank">人民政协报：以_全人_角度看待留守儿童成长教育</a>
        </li>
        <li>
          促进我国青少年发展的新视角：积极青少年发展的框架与路径 <a :href="src1" target="_blank">全文下载</a>
        </li>
        <li>
          流动儿童积极发展与心理健康状况评估报告 <a :href="src2" target="_blank">全文下载</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "advice",
  data() {
    return {
      src1:[require('../../assets/pdf/4.3.pdf')],
      src2:[require('../../assets/pdf/4.4.pdf')]
    };
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>




// WEBPACK FOOTER //
// src/components/tabs/advice.vue